import Cookies from 'js-cookie'

const CSRF_COOKIE = 'csrf'
const SHARED_COOKIE_DOMAIN = 'pokemonrevolution.net'

function sharedCookieDomain () {
  if (typeof window === 'undefined') {
    return ''
  }

  const hostname = window.location.hostname.toLowerCase()
  if (hostname === SHARED_COOKIE_DOMAIN || hostname.endsWith(`.${SHARED_COOKIE_DOMAIN}`)) {
    return SHARED_COOKIE_DOMAIN
  }
  return ''
}

function cookieOptions () {
  const domain = sharedCookieDomain()
  const options = {
    expires: 4000,
    path: '/',
    sameSite: 'Lax',
    secure: window.location.protocol === 'https:'
  }

  if (domain) {
    options.domain = domain
  }

  return options
}

function persistToken (token) {
  const domain = sharedCookieDomain()
  Cookies.set(CSRF_COOKIE, token, cookieOptions())

  if (domain) {
    Cookies.remove(CSRF_COOKIE, { path: '/' })
  }
}

function secureRandomToken () {
  if (typeof window === 'undefined' || !window.crypto || !window.crypto.getRandomValues) {
    return null
  }

  const bytes = new Uint8Array(32)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}

export function csrfToken () {
  const existing = Cookies.get(CSRF_COOKIE)
  if (existing) {
    persistToken(existing)
    return existing
  }

  const token = secureRandomToken()
  if (!token) {
    return null
  }

  persistToken(token)
  return token
}
